import { Injectable } from '@angular/core';
import { GoogleMapType } from '../../enums/google-map-enum';
import { GoogleMapStoreService } from '../google-map-store/google-map-store.service';
import { GoogleMapsAPIWrapperService } from '../google-map-wrapper/google-maps-api-wrapper.service';
import { GoogleMapConfigService } from '../google-map-config/google-map-config.service';
import { IGoogleMap } from 'src/app/core/models/google-map-models';
import { HybridGoogleMap } from '../../models/hybrid-google-map';
import { RoutePlannerDataModel } from '../../../route-planner/models/route-model';
import { RoutePlannerHybridGoogleMap } from '../../models/route-planner-google-map';
import { GoogleMapGeoService } from 'src/app/modules/aa-core/services/google/aa-google-geo/google-map-geo.service';
import { AAGoogleIconService } from 'src/app/modules/aa-core/services/google/aa-google-icon/aagoogle-icon.service';
import { RoutePlannerService } from 'src/app/modules/route-planner/services/route-planner/route-planner.service';
import { GoogleMapRouteService } from '../google-map-route/google-map-route.service';
import { RoutePlannerLocalStoreService } from 'src/app/modules/aa-core/services/route-planner-local-store/route-planner-local-store.service';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { GoogleCacheManagerService } from '../google-cache-manager/google-cache-manager.service';

@Injectable({
  providedIn: 'root'
})
export class HybridGoogleMapService {

  private routeDataModel: RoutePlannerDataModel;

  constructor(
    private appUtiltService: AppUtilityService,
    private routePlannerLocalStore: RoutePlannerLocalStoreService,
    private googleMapStore: GoogleMapStoreService,
    private mapsWrapper: GoogleMapsAPIWrapperService,
    private mapConfig: GoogleMapConfigService,
    private routePlannerService: RoutePlannerService,
    private googleMapGeoUtils: GoogleMapGeoService,
    private googleMapRouteService: GoogleMapRouteService,
    private googleMapCacheManager: GoogleCacheManagerService,
    private googleIconService: AAGoogleIconService) {
    this.routeDataModel = this.routePlannerService.routeDataModel;
  }

  public setupHybridGoogleMap(gmapElement: any, mapType: GoogleMapType, data?: any): void {
    const mapConfig = this.mapConfig.getGoogleMapConfig(null, this.appUtiltService.isStrictlyMobile);

    if (mapType >= 1000) {
      mapConfig.zoom = 15;
    } else if (mapType ===  GoogleMapType.TRAFFIC_NEWS || mapType === GoogleMapType.MAPS) {
      // mapConfig.zoom = 13;
    }

    this.mapsWrapper.createMap(gmapElement.nativeElement, mapConfig).then((googleMap: IGoogleMap) => {
        const googleMapModel = this.googleMapStore.getGoogleMapModel(mapType);
        let googleMapInstance: HybridGoogleMap;

        if (googleMapModel) {
          googleMapInstance = googleMapModel.mapInstance;
        } else {
          switch (mapType) {
            case GoogleMapType.ROUTE_PLANNER:
              googleMapInstance = new RoutePlannerHybridGoogleMap(mapType);
              break;
            case GoogleMapType.TRAFFIC_NEWS:
            case GoogleMapType.MAPS:
            case GoogleMapType.ROUTE_PRINT_MAP:
            case GoogleMapType.ROUTE_PRINT_PREVIEW:
            default:
              googleMapInstance = new HybridGoogleMap(mapType);
              break;
          }
          googleMapInstance.mapConfig = this.mapConfig;
          googleMapInstance.setDependency(this.googleMapGeoUtils, this.googleIconService,
            this.mapsWrapper, this.googleMapRouteService, this.routePlannerLocalStore, this.googleMapCacheManager);
        }
        googleMapInstance.setGoogleMap(googleMap);
        googleMapInstance.initMap(this.routeDataModel);

        if (mapType === GoogleMapType.ROUTE_PRINT_PREVIEW || mapType === GoogleMapType.ROUTE_PRINT_MAP || mapType >= 1000) {
          googleMapInstance.updateMapData(data);
        }

        // update google map store;
        this.googleMapStore.setGoogleMap(mapType, googleMap, googleMapInstance);

        if (mapType === GoogleMapType.TRAFFIC_NEWS) {
          googleMapInstance.addTrafficLayer();
        }
      })
      .catch(error=>{
        console.log(error);
      })
  }

  public removeGoogleMap(mapType: GoogleMapType): void {
    const googleMapModel = this.googleMapStore.getGoogleMapModel(mapType);
  }

}
